// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__wereT","right":"Footer_right__3TKAp","buttons":"Footer_buttons__1Bqx8"};